import React, { useEffect, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { srConfig } from '../config.js';
import sr from '../utils/sr.js';
import { usePrefersReducedMotion } from '../hooks/index.js';

const StyledAboutSection = styled.section`
  max-width: 900px;
  ${'' /* margin-left:300px; */}

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
  .head{
    margin-bottom: 34px;
    color: #ccd6f6;
    font-size: 30px;
    font-weight: 650;
  }
  .num{
    margin-bottom: 34px;
    margin-right:15px;
    color: #64ffda;
    font-size: 24px;
    font-weight: 500;
  }
  .bor{
    margin-left:40px;
    max-width:300px;
    border-color:#233554;

  }

`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;
      font-size: 13px;
      color: #8892b0;

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: #64ffda;
        font-size:14px;
        line-height: 12px;
      }

      
    }
  }

  p{
    color: #8892b0;
    margin-bottom: 10px;
    text-align: left;
    text-overflow: ellipsis;
    max-width: 470px;
  }
`;
const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  .wrapper {
    display: block;
    position: relative;
    width: 100%;
    border-radius: 4px;
    background-color: #64ffda;

    &:hover,
    &:focus {
      outline: 0;
      transform: translate(-4px, -4px);

      &:after {
        transform: translate(8px, 8px);
      }

      .img {
        filter: none;
        mix-blend-mode: normal;
      }
    }

    .img {
      position: relative;
      border-radius: 4px;
      mix-blend-mode: multiply;
      filter: grayscale(100%) contrast(1);
      transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    }

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius:  4px;
      transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
    }

    &:before {
      top: 0;
      left: 0;
      background-color: #0a192f;
      mix-blend-mode: screen;
    }

    &:after {
      border: 2px solid #64ffda;
      top: 14px;
      left: 14px;
      z-index: -1;
    }
  }
`;

export default function About() {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const skills = ['JavaScript (ES6+)', 'React', 'Node.js', 'ExpressJS'];

  return (
    <StyledAboutSection id="about"ref={revealContainer}>

    <h2 className="numbered-heading ">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>
            Hi, I'm Jaimin Viramgama. Currently, I'm studying Computer Science at the Indian Institue of Technology, Tirupati.  I'm enthusiastically grabbing onto all learning opportunities that can help me put a valuable impact on the society.
            </p>

            <p>
            I've been quite active in building up full-stack web applications and dealing with real world problems. I am also very passionate about Artificial Intelligence and Machine Learning. I am always looking for opportunities to learn and grow.
            </p>

            <p>
            When I'm not in front of a computer screen, I'm probably out for a run, watching my favourite shows, listening to music or reading a book.
            </p>

            <p>Here are a few technologies I’ve been working with recently:</p>
          </div>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledText>

        <StyledPic>
          <div className="wrapper">
            {/* <img
              className="img"
              src="../../images/me.jpg"
              width={500}
              quality={95}
              formats={['AUTO', 'WEBP', 'AVIF']}
              alt="Headshot"
            /> */}

            <img className="img" width={500} quality={95} src="https://lh3.googleusercontent.com/drive-viewer/AKGpihaIlCCvrqLsB7fkgCo161Z89paRMc9h-7ebat8Hn9BjR4SYGJmvNO7fqme8_9D0Wev20bJtlNZ9gIV3I89xNwH__NaYgHa3Zbs=s1600-rw-v1" alt="profile"/>
          </div>
        </StyledPic>
      </div>
    </StyledAboutSection>
  );
}